import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { transformStr3, getformListItemsdata } from "@/utils/utils";
export default {
  name: 'scenicspot',
  meta: {
    title: '景点'
  },
  data() {
    return {
      fid: this.$route.query.fid,
      // this.$route.query.cfId
      formconfig: {
        formId: '264843_1',
        page: 1,
        limit: 10
      },
      dataList: [],
      total: 0,
      totalPage: 0
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      let _this = this;
      this.formconfig.deptId = this.fid;
      this.$api.singleadvanceSearch(this.formconfig).then(res => {
        // console.log(res)
        _this.total = res.totalRow;
        _this.totalPage = res.totalPage;
        // 格式化数据
        if (res.dataList.length > 0) {
          _this.dataList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdata(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            return item;
          });
        }
      });
    },
    currentChange(val) {
      this.formconfig.page = val;
      this.dataList = [];
      this.getList();
    },
    goLink(val) {
      if (val.itemformdata[34] === '') {
        // 返回详情页
        let detailurl = '#/' + 'scenicspotdetail' + '?fid=' + this.fid + '&formUserId=' + val.id + '&pageId=' + this.$route.query.pageId;
        return detailurl;
      } else {
        return val.itemformdata[34];
      }
    }
  }
};